import { ArrowRightOutlined } from '@ant-design/icons'
import { useRequest } from 'ahooks'
import { Collapse, CollapsePanelProps, List, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { getNameLink, getResourceTag } from '@/components/special-project-relations.component'

export const MyAudit: React.FC<CollapsePanelProps> = (props) => {
  const { t } = useTranslation()

  const { data, loading } = useRequest({
    url: '/api/relations/getAuditsBySelf',
  })

  if (!data) {
    return null
  }

  const header = <span>{props.header}</span>

  return (
    <Collapse.Panel {...props} header={header}>
      <List
        className='max-h-600px overflow-y-auto'
        itemLayout='horizontal'
        loading={loading}
        size='small'
        bordered
        locale={{ emptyText: <div className='text-left'>我的{t('audit.title')}在此展示</div> }}
        dataSource={data}
        renderItem={(resource: any) => (
          <List.Item className='space-x-24px '>
            <div>
              <Typography.Text>
                {getNameLink({
                  name: resource.project?.name || resource.portfolio?.name,
                  type: resource.type,
                  selfId: resource.selfId,
                })}
                {getResourceTag({ type: resource.type, className: 'ml-2' })}
              </Typography.Text>
              <ArrowRightOutlined className='text-grey-200 mx-4' />
              <Typography.Text>
                {getNameLink({
                  name: resource.parentProduction?.name || resource.parentCustomer?.name || resource.parentDevlop?.name,
                  type: resource.parentType,
                  selfId: resource.parentSelfId,
                })}
                {getResourceTag({ type: resource.parentType, className: 'ml-2' })}
              </Typography.Text>
            </div>
            {getNameLink({
              name: t('audit.title'),
              type: resource.parentType,
              selfId: resource.parentSelfId,
              params: { tab: 'audit' },
            })}
          </List.Item>
        )}
      />
    </Collapse.Panel>
  )
}
